import { Link } from 'react-router-dom';
import { latestComics, categories } from '@/mocks/home';

export default function LatestUpdates() {
  const tabCategories = ['全部', ...categories.slice(0, 4).map(c => c.name)];

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-xs font-medium text-foreground-400 uppercase tracking-wider block mb-2">
              Latest Updates
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold italic text-foreground-950">
              最新更新
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            每日海量更新，热门连载、新作上线一网打尽。下拉式流畅阅读，随时随地追更不等待。
          </p>
        </div>

        <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
          {tabCategories.map((tab, idx) => (
            <button
              key={tab}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                idx === 0
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3">
                <img
                  src={comic.image}
                  alt={comic.title}
                  title={`${comic.title} - ${comic.category}韩漫`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading={idx > 3 ? 'lazy' : undefined}
                />
                <div className={`absolute top-2 left-2 ${idx === 2 ? 'bg-accent-500' : 'bg-foreground-900/75'} text-background-50 text-xs font-medium px-2 py-1 rounded-md`}>
                  {comic.category}
                </div>
                <div className="absolute bottom-2 right-2 bg-background-50/90 text-foreground-800 text-xs font-medium px-2 py-1 rounded-md backdrop-blur-sm">
                  {comic.chapter}
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors duration-150">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">{comic.updateTime}</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-all duration-200"
          >
            浏览全部漫画
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}